import { combineReducers } from "redux";
import { routerReducer } from "react-router-redux";
import Auth from "./Auth";
import notification from "./Notification";
import setting from "./setting";

const createRootReducer = combineReducers({
  routing: routerReducer,
  auth: Auth,
  notification: notification,
  setting: setting
});

export default createRootReducer;
